Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.Vote = Marionette.Behavior.extend({
        ui: {
            voteButton: '.vote_button',
            voteCount: '.vote_count'
        },
        modelEvents: {
            'voted': 'onVoted',
            'lightboxVote': 'onLightboxVote'
        },
        events: {
            'click @ui.voteButton': 'onVoteClicked'
        },

        // DistinctUserHash
        canGetDuh: function() {
            return gon.distinct_user_hash !== undefined || window.analytics && window.analytics.getAnonymousId;
        },

        getDuh: function() {
            if (this.canGetDuh()) {
                return gon.distinct_user_hash || window.analytics.getAnonymousId();
            }
            return null;
        },

        showVoteButtonText: function(buttonStatus, likes) {

            // corresponds to the yml file variables; "widget.vote" or "widget.voted"
            var buttonText = 'widget.' + buttonStatus;

            // When likes are not passed as a param, the text only version will show
            if (gon.display_options.showVoteCount && likes) {
                this.ui.voteButton.text(I18n.t('widget.vote_count', {
                    label: I18n.t(buttonText),
                    count: likes
                }));
            } else {
                this.ui.voteButton.text(I18n.t(buttonText));
            }
        },

        onVoteClicked: function() {
            var duh = this.getDuh();
            // can't vote if we can't get duh
            if (!duh) {
                return;
            }

            this.voteInterval = this.voteInterval || (gon.current_album && gon.current_album.vote_interval);

            // optimistically add active class and update button text
            if (!this.ui.voteButton.hasClass('active')) {
                this.showVoteButtonText('voted');
                this.ui.voteButton.addClass('active');
            }

            $.ajax({
                url: '/social/like',
                type: 'POST',
                data: {
                    id: this.view.model.get('album_photo_id'),
                    distinct_user_hash: duh,
                    fingerprint: gon.fingerprint
                },
                dataType: 'json',
                success: function(response) {
                    if (response.pixlee_likes) {
                        var data = {
                            name: 'pixlee:save:votes',
                            type: 'action',
                            source: 'lightbox',
                            destination: 'parent',
                            data: {
                                'pixlee_likes': response.pixlee_likes
                            }
                        };

                        window.parent.postMessage(JSON.stringify(data), '*');
                    }

                    if (response.error_code === 0) {
                        //vote successfull
                        this.view.model.set({
                            'like_count': response.like_count,
                            'userVoted': true
                        });

                        this.view.model.trigger('voted');
                    } else if (response.error_code === 1) {
                        //album
                        //console.log('album_photo dosn't exist');
                    } else if (response.error_code === 2) {
                        //console.log("couldn't save the like something went wrong retry");
                        //reset button UI
                        this.ui.voteButton.removeClass('active');
                        this.showVoteButtonText('vote', this.view.model.get('like_count'));

                    } else if (response.error_code === 3) {
                        //console.log("this user already voted");
                        //The cookies must have been deleted reset them
                        this.view.model.set('userVoted', true);
                        // this.view.model.attributes.userVoted = true;
                        this.view.model.trigger('voted');
                    }
                }.bind(this)
            });
        },
        onVoted: function() {
            this.ui.voteButton.addClass('active');
            this.showVoteButtonText('voted', this.view.model.get('like_count'));

            var permanentVoteOptions = [undefined, null, '1 day', '7 days', '1 year'];
            //if we manually set the voted to be a few seconds (like we do for puma), then they get infinite voting

            if (permanentVoteOptions.indexOf(this.voteInterval) === -1) {
                //once the vote registers, then we remove the colour so they can immediately vote again
                this.view.model.set('userVoted', false);
                this.ui.voteButton.removeClass('active');
                this.showVoteButtonText('vote', this.view.model.get('like_count'));
            }
        },
        onLightboxVote: function() {
            this.ui.voteButton.addClass('active');
            this.onVoteClicked();
        },
        onShow: function() {
            // can't vote if we can't get duh
            // NOTE: Due to firefox privacy policies, firefox default settings prevent fingerprinting code to run, which means we can't prevent fradulent votes
            // This means the canGetDuh() will always return undefined
            // as a result of that, we hide the vote button on firefox.
            if (!this.canGetDuh()) {
                this.ui.voteButton.hide();
            }
        }
    });
    Behaviors.CollectionVote = Marionette.Behavior.extend({
        collectionEvents: {
            'sync': function() {
                this.firstLoad = true;
                this.onSync(this);
            }
        },
        initialize: function() {
            var _this = this;

            //mosaic uses a different collection name to run stuff so the built in "collectionEvents" hash won't ever sync
            if (this.view.options.collectionQueue) {
                this.view.options.collectionQueue.on('sync', function() {
                    this.firstLoad = true;
                    this.onSync(this);
                }.bind(this));
            }

            App.commands.setHandlers({
                'vote:loaded': _.bind(this.onSync, this)
            });

            window.addEventListener('message', function(event) {
                var message;
                if (event.data) {
                    try {
                        message = JSON.parse(event.data);
                    } catch (error) {
                        // Some other way of sending data, ignore
                        return;
                    }
                } else {
                    return;
                }
                if (message.name && message.name === 'pixlee:lightbox:vote') {
                    var photo = JSON.parse(message.data);
                    var idsMatchedOnce = false;
                    _.each(_this.view.collection.models, function(item) {
                        var idsMatch = item.get('album_id') + '_' + item.get('album_photo_id') === photo.album_id + '_' + photo.album_photo_id;
                        if (idsMatch) {
                            item.trigger('lightboxVote');
                            item.set('userVoted', true);
                        }
                        idsMatchedOnce = idsMatchedOnce || idsMatch;
                    });

                    // When a lightbox photo is linked to, but hasn't been paginated to yet in the widget
                    if (!idsMatchedOnce) {
                        var duh = gon.distinct_user_hash || window.analytics.getAnonymousId();
                        if (!duh) {
                            return;
                        }
                        $.ajax({
                            url: '/social/like',
                            type: 'POST',
                            data: {
                                id: photo.album_photo_id,
                                distinct_user_hash: duh,
                                fingerprint: gon.fingerprint
                            },
                            dataType: 'json'
                        });
                    }
                }
            }, false);

        },
        onSync: function(self) {
            if (gon.pixlee_votes && gon.pixlee_votes.length > 0 && this.firstLoad) {
                // If Rails is able to send pixlee_votes on gon without any cookie restriction, this will update the parent website cookies as well.
                // If not, votes will update again on next vote

                var data = {
                    name: 'pixlee:save:votes',
                    type: 'action',
                    source: 'lightbox',
                    destination: 'parent',
                    data: {
                        'pixlee_likes': gon.pixlee_votes
                    }
                };

                window.parent.postMessage(JSON.stringify(data), '*');

                //make sure we grab the correct collection (mosaic vs all others)
                var currentCollection = this.view.collectionQueue ? this.view.collectionQueue.models : this.view.collection.models;
                _.each(currentCollection, function(item) {
                    if (_.indexOf(gon.pixlee_votes, item.get('album_id') + '_' + item.get('album_photo_id')) != -1) {
                        item.trigger('voted');
                        item.set('userVoted', true);
                    }
                });
            }
        }
    });

});
